import { useQuery } from '@tanstack/react-query';
import {
  rateActionApi,
  rateActionKeys,
  type RateActionExtractRequestSummary,
} from '../api/rate-action-api';

const STALE_TIME_MS = 30_000;

export function useRateActionExtractRequests(clientId: string | undefined) {
  return useQuery<RateActionExtractRequestSummary[]>({
    queryKey: rateActionKeys.list({ clientId }),
    queryFn: () => rateActionApi.listRequests(clientId!),
    enabled: !!clientId,
    staleTime: STALE_TIME_MS,
  });
}
